import { render, staticRenderFns } from "./PastaCompartilhamentoAcoes.vue?vue&type=template&id=7c7bbd4e"
import script from "./PastaCompartilhamentoAcoes.vue?vue&type=script&lang=js"
export * from "./PastaCompartilhamentoAcoes.vue?vue&type=script&lang=js"
import style0 from "./PastaCompartilhamentoAcoes.vue?vue&type=style&index=0&id=7c7bbd4e&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports